import { render, staticRenderFns } from "./GeneralLoader.vue?vue&type=template&id=4eb5f8b3&"
var script = {}
import style0 from "./GeneralLoader.vue?vue&type=style&index=0&id=4eb5f8b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports